import React, {PropTypes} from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormControl } from 'react-bootstrap';
import Checkmark from '../../core/components/Checkmark'

class AddMemberForm extends React.Component {

  constructor(props) {
    super(props)
  }

  renderField({ input, label, type, meta: { touched, error } }) {
    return (
      <div>
        <FormControl {...input} componentClass="textarea"
          placeholder="Example: jane@gmail.com, gabe@yahoo.com, rachel@outlook.com, ash@gmail.com, alex@yahoo.com, jane@outlook.com, dan@gmail.com, adam@outlook.com, rachel@gmail.com, alex@outlook.com, jacob@gmail.com, jane2@gmail.com, gabe3@yahoo.com, rachel4@outlook.com, ash5@gmail.com, alex6@yahoo.com, jane7@outlook.com, dan8@gmail.com, adam9@outlook.com"
        />
      </div>
    )
  }

  render() {
    const { handleSubmit, submitting, createMemberInvitesForm, onCreateMemberInvitesFormReset } = this.props;


    var buttonContent;
    if (createMemberInvitesForm.success) {
      buttonContent = <Checkmark/>
      setTimeout(function(){ onCreateMemberInvitesFormReset() }, 3000);
    } else {
      buttonContent = submitting ? "Sending..." : "Send Invites"
    }

    return (<div>

      <form className="add-client-form" onSubmit={handleSubmit}>
        <div>
            <Field
              name="emails"
              component={this.renderField}
              type="text"
            />
        </div>
        <button className="btn btn-main-green" type="submit" disabled={submitting}>{buttonContent}</button>
      </form>


    </div>);
  }
}

AddMemberForm = reduxForm({
  form: 'AddMemberForm' // a unique name for this form
})(AddMemberForm);

export default AddMemberForm;

AddMemberForm.propTypes = {
};



// WEBPACK FOOTER //
// ./src/accountants/components/AddMemberForm.js